module.exports = __webpack_public_path__ + "static/media/no-image-available-icon.855e8ca0.jpg";